import React from "react";
import "../ProductCardsModems.css";
import { Link } from "react-router-dom"; 
import '../../i18n';
import { useTranslation } from 'react-i18next';

import ImageSpin57Quanta from "../../assets/images/modems/processed/quanta_spin57.png"

const Spin57_QUANTA = () => {
  const { t, i18n } = useTranslation();
  
  return (
     <Link to="/acoustic_modems#spin57_quanta_spec" className="card-link-wrapper">
        <div class="card">
          <img src={ImageSpin57Quanta} alt={t('products.types.communcation_57_QUANTA.title')} class="card-image" />
          <div class="card-content">
            <h3 class="card-title">{t('products.types.communcation_57_QUANTA.title')}</h3>
            <p className="card-description">
              <ul class="features-list">
                <li>{t('products.types.communcation_57_QUANTA.li_1')}</li>
                <li>{t('products.types.communcation_57_QUANTA.li_2')}</li>
                <li>{t('products.types.communcation_57_QUANTA.li_3')}</li>
                <li>{t('products.types.communcation_57_QUANTA.li_4')}</li>
                <li>{t('products.types.communcation_57_QUANTA.li_5')}</li>
                <li>{t('products.types.communcation_57_QUANTA.li_6')}</li>
              </ul>
            </p>
          </div>
        </div>
      </Link>
  );
};
export default Spin57_QUANTA;